<style>
#file-drag-drop {
  margin-bottom: 2em;
}

#file-drag-drop form {
  display: block;
  height: 100px;
  background: #ccc;
  text-align: center;
  line-height: 100px;
  border-radius: 4px;
}
form.is-dragover {
  background-color: #17c4ee;
  color: #ffffff;
}

div.file-listing {
  margin: auto;
  border-bottom: 1px solid #ddd;
}
div.file-listing table {
  margin: 0px;
  font-size: 0.9em;
  line-height: 1.8em;
}
div.file-listing table .icon {
  font-size: 1.2em;
}
div.file-listing img {
  height: 100px;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}

progress {
  width: 400px;
  margin: auto;
  display: block;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>

<template>
  <div id="file-drag-drop">
    <form ref="fileform" class="dragdropform">
      <span class="drop-files">Drop the files here!</span>
    </form>
    <div v-for="(file, key) in list" class="file-listing" :key="file.id">
      <table class="table">
        <tbody>
          <tr>
            <td style="width: 5%;">
              <!-- <img class="preview" v-bind:ref="'preview'+parseInt( key )"/> -->
              <span class="icon is-small is-left">
                <i v-bind:ref="'preview'+parseInt( key )"></i>
              </span>
            </td>

            <td style="width: 80%;">
              <a :href="'/storage/attachments/'+newFilenames[key]" target="_blank">{{ file.name }}</a>
              <small style="color: #ccc;">[{{ formatBytes(file.size) }}]</small>
            </td>

            <td style="width: 10%;">
              <div class="remove-container">
                <a class="remove" v-on:click="removeFile( key )">Remove</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <progress max="100" :value.prop="uploadPercentage"></progress> -->

    <a class="submit-button" v-on:click="submitFiles()" v-show="files.length > 100">Submit</a>
  </div>
</template>

<script>
export default {
  /*
      Variables used by the drag and drop component
    */
  data() {
    return {
      dragAndDropCapable: false,
      files: [],
      list: [],
      listid: [],
      newFilenames: [],
      originalFilenames: [],
      uploadPercentage: 0,
    };
  },

  mounted() {
    /*
        Determine if drag and drop functionality is capable in the browser
      */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
        If drag and drop capable, then we continue to bind events to our elements.
      */
    if (this.dragAndDropCapable) {
      /*
          Listen to all of the drag events and bind an event listener to each
          for the fileform.
        */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop",
      ].forEach(
        function (evt) {
          /*
            For each event add an event listener that prevents the default action
            (opening the file in the browser) and stop the propagation of the event (so
            no other elements open the file in the browser)
          */

          this.$refs.fileform.addEventListener(
            evt,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      this.$refs.fileform.addEventListener(
        "dragenter",
        function (e) {
          this.$refs.fileform.className = "is-dragover";
        }.bind(this)
      );

      this.$refs.fileform.addEventListener(
        "dragleave",
        function (e) {
          this.$refs.fileform.className = "";
        }.bind(this)
      );

      /*
          Add an event listener for drop to the form
        */
      this.$refs.fileform.addEventListener(
        "drop",
        function (e) {
          /*
            Capture the files from the drop event and add them to our local files
            array.
          */
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push(e.dataTransfer.files[i]);
            this.list.push(e.dataTransfer.files[i]);
          }
          this.getFileExtensionIcons();
          /*
            Instantly upload files
          */
          this.submitFiles();

          this.$refs.fileform.className = "";
        }.bind(this)
      );
    }
  },

  methods: {
    formatBytes(a, b) {
      if (0 == a) return "0 Bytes";

      var c = 1024,
        d = b || 2,
        e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        f = Math.floor(Math.log(a) / Math.log(c));

      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
    },

    /*
        Determines if the drag and drop functionality is in the
        window
      */
    determineDragAndDropCapable() {
      /*
          Create a test element to see if certain events
          are present that let us do drag and drop.
        */
      var div = document.createElement("div");

      /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.

          We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    /*
        Gets the image preview for the file.
      */
    getFileExtensionIcons() {
      /*
          Iterate over all of the files and generate an image preview for each one.
        */
      for (let i = 0; i < this.list.length; i++) {
        /*
            Ensure the file is an image file
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.list[i].name)) {
          //let reader = new FileReader();
          //reader.addEventListener("load", function(){
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].className =
              "fas fa-file-image";
          });
          //}.bind(this), false);
          //reader.readAsDataURL( this.files[i] );
        } else if (/\.(pdf)$/i.test(this.list[i].name)) {
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].className =
              "fas fa-file-pdf";
          });
        } else if (/\.(doc|docx?)$/i.test(this.list[i].name)) {
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].className =
              "fas fa-file-word";
          });
        } else {
          /*
              We do the next tick so the reference is bound and we can access it.
            */
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].className = "fas fa-file";
          });
        }
      }
    },

    /*
        Gets the image preview for the file.
      */
    getImagePreviews() {
      /*
          Iterate over all of the files and generate an image preview for each one.
        */
      for (let i = 0; i < this.files.length; i++) {
        /*
            Ensure the file is an image file
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          /*
              Create a new FileReader object
            */
          let reader = new FileReader();

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener(
            "load",
            function () {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );

          /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
          reader.readAsDataURL(this.files[i]);
        } else {
          /*
              We do the next tick so the reference is bound and we can access it.
            */
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].src = "/images/file.jpg";
          });
        }
      }
    },

    removeFile(key) {
      let formData = new FormData();
      let originalFilename = this.originalFilenames[key];
      let newFilename = this.newFilenames[key];
      let dbID = this.listid[key];

      formData.append("originalFilename", originalFilename);
      formData.append("newFilename", newFilename);
      formData.append("dbID", dbID);

      alert(key);

      axios
        .post("/filemanagement/deleteFile", formData)
        .then((response) => {
          this.listid.splice(key, 1);
          this.list.splice(key, 1);
          this.newFilenames.splice(key, 1);
          this.originalFilenames.splice(key, 1);
          this.$emit("removeFileID", dbID);
          console.log("File Deleted!!");
        })
        .catch(function () {
          console.log("Delete Failure!!");
        });
    },

    /*
        Submits the files to the server
      */
    submitFiles() {
      /*
          Initialize the form data
        */
      let self = this;
      let formData = new FormData();

      /*
          Iteate over any file sent over appending the files
          to the form data.
        */
      for (var i = 0; i < this.files.length; i++) {
        /* 
          Get file attachments
          */
        let file = this.files[i];
        let filename = file.name;
        let filesize = file.size;
        let filetype = file.type;
        formData.append("files[" + i + "]", file);
        formData.append("fileTypes[" + i + "]", filetype);
        formData.append("fileSizes[" + i + "]", filesize);
        formData.append("originalFilenames[" + i + "]", filename);

        //console.log(filesize);
        console.log(filetype);
        //console.log(filename);

        /*
          Generate new filename(s) based on timestamp + random string
          */
        let dateTime = Date.now();
        let timestamp = Math.floor(dateTime / 1000);

        let re = /(?:\.([^.]+))?$/;
        let fileextension = re.exec(filename)[1].toLowerCase();
        /* OR */
        //let fileextension = filename.split('.').pop();

        let newFilename =
          timestamp + "_" + this.generateRandomString(4) + "." + fileextension;
        formData.append("newFilename[" + i + "]", newFilename);

        this.newFilenames.push(newFilename);
        this.originalFilenames.push(filename);
      }

      /*
          Make the request to the POST /file-drag-drop URL
        */
      axios
        .post("/api/filemanagement/file-drag-drop-instant", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        })
        .then((response) => {
          // console.log("RESPONSE: " + response.data.fileId);
          self.listid = [];

          for (let i = 0; i < response.data.fileId.length; i++) {
            // console.log(i + ": " + response.data.fileId[i]);
            self.listid.push(response.data.fileId[i]);
          }

          // alert(self.listid);
          this.$emit("fileIDs", self.listid);
          //self.files.push(newFilename);
          console.log("File Uploaded Successfully!!");
          this.files = [];
        })
        .catch(function () {
          console.log("Failed to upload file!!");
        });
    },

    generateRandomString(len) {
      let chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let randomString = "";

      for (let i = 0; i < len; i++) {
        randomString += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return randomString;
    },
  },
};
</script>


// WEBPACK FOOTER //
// Modules/FileManagement/Resources/assets/js/components/FileDragDropInstant.vue